export const StockUploadColumns = [
    "SNo",
    "Unit",
    "Date",
    "TransactionType",
    "JobCode",
    "StockType",
    "CustomerPo",
    "LotCode",
    "GradeChange",
    "SoakingProduct",
    "Product",
    "PackStyle",
    "Cartons",
    "LoosePouches",
    "Shift",
    "Freezer",
    "WHIncharge",
    "RackPosition",
    "ProductCategory",
    "RejectionFrom",
    "JobCompleted"
]